import React from 'react';

const NoOp = () => null;

NoOp.displayName = 'NoOp';
NoOp.propTypes = {};

export { NoOp };
